module.exports = __webpack_public_path__ + "static/media/Brighter Days.6db08540.jpg";